var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { NavLink, Link } from 'react-router-dom';
import Icon from '../Icon';
import Typography from '../Typography';
import Button from '../Button';
import ProfilePhoto from '../ProfilePhoto';
import { getUniqueKey } from '../utils';
import { SideBarWrapperStyled, SideBarStyled, SideBarTitleStyled, SideBarTypography, SideBarDividerStyled, SideBarCloseButtonStyled, SideBarBottomContentStyled, SideBarTopContentStyled, SideBarSubContentWrapperStyled, } from './styled';
const SideBarTitleItem = (_a) => {
    var props = __rest(_a, []);
    const { title, icon, clicked, level, sections, last: lastChild, openSide, variant } = props;
    const [clickedItem, setClickedItem] = useState(clicked);
    return (_jsxs("div", Object.assign({ style: { position: 'relative' } }, { children: [_jsxs(SideBarTitleStyled, Object.assign({ openSide: openSide, last: lastChild, level: level, clicked: clickedItem, onClick: () => setClickedItem(!clickedItem) }, { children: [level === 0 && (_jsx(Icon, { name: icon, color: clickedItem ? '#0057b8' : '#8E90A4', style: {
                            transition: 'all 0.3s ease-in-out',
                        } })), _jsx(SideBarTypography, Object.assign({ className: openSide || variant === 'mobile' ? '' : `hidden`, variant: variant, level: level, clicked: clickedItem, openSide: openSide }, { children: title })), _jsx(Icon, { name: "keyboardArrowDownRounded", color: clickedItem ? '#0057b8' : '#8E90A4', size: openSide ? '24px' : '16px', style: {
                            display: openSide || variant === 'mobile' || level > 0 ? 'flex' : 'none',
                            transform: `rotate(${clickedItem ? '0deg' : '-90deg'})`,
                            transition: 'all 0.3s ease-in-out',
                        } })] })), _jsx(SideBarSubContentWrapperStyled, Object.assign({ level: level, clicked: clickedItem, openSide: openSide }, { children: sections.map((_a, index) => {
                    var subContentProps = __rest(_a, []);
                    return (
                    // eslint-disable-next-line @typescript-eslint/no-use-before-define
                    _jsx(SideBarContent, Object.assign({}, subContentProps, { level: level + 1, last: index === sections.length - 1, openSide: openSide, variant: variant }), getUniqueKey()));
                }) }))] })));
};
const SideBarLink = (_a) => {
    var { url, children } = _a, rest = __rest(_a, ["url", "children"]);
    if (!url)
        return _jsx("span", { children: children });
    const Component = url.startsWith('/') ? NavLink : Link;
    return (_jsx("span", { children: _jsx(Component, Object.assign({}, Object.assign(Object.assign({}, rest), { to: url, style: { textDecoration: 'none' } }), { children: children })) }));
};
const SideBarContent = (_a) => {
    var props = __rest(_a, []);
    const { title, icon, sections, color, url, onClick } = props, sideBarTitleProps = __rest(props, ["title", "icon", "sections", "color", "url", "onClick"]);
    const { openSide, last, level, variant } = sideBarTitleProps;
    if (!sections || !sections.length) {
        return (_jsx(SideBarLink, Object.assign({ url: url, onClick: onClick }, { children: _jsxs(SideBarTitleStyled, Object.assign({}, props, { last: last }, { children: [level === 0 && _jsx(Icon, { name: icon, color: color || '#8E90A4' }), _jsx(SideBarTypography, Object.assign({ className: openSide || variant === 'mobile' ? '' : 'hidden', level: level, openSide: openSide, style: color ? { color } : {} }, { children: title }))] })) }), getUniqueKey()));
    }
    return (_jsx("div", { children: _jsx(SideBarTitleItem, Object.assign({}, props)) }, getUniqueKey()));
};
const SideBarBottomContent = ({ open, bottomContent: content, variant }) => {
    return (_jsxs("div", Object.assign({ style: {
            width: open || variant === 'mobile' ? '100%' : '100px',
            transform: 'width 0.3s ease-in-out',
        } }, { children: [_jsx(SideBarDividerStyled, {}), _jsx(SideBarBottomContentStyled, Object.assign({ openSide: open }, { children: content &&
                    content.map((_a) => {
                        var subContentProps = __rest(_a, []);
                        return (_jsx(SideBarContent, Object.assign({}, subContentProps, { level: 0, openSide: open, variant: variant }), getUniqueKey()));
                    }) }))] })));
};
const SideBarTopContent = ({ userPhoto, userName, open, variant, onClickPhoto }) => {
    return (_jsxs("div", Object.assign({ style: {
            width: open || variant === 'mobile' ? '100%' : '100px',
            transform: 'width 0.3s ease-in-out',
        } }, { children: [_jsxs(SideBarTopContentStyled, Object.assign({ openSide: open, variant: variant, onClick: onClickPhoto }, { children: [_jsx(ProfilePhoto, { size: open || variant === 'mobile' ? 60 : 30, src: userPhoto }), _jsxs("div", Object.assign({ style: {
                            display: open || variant === 'mobile' ? 'flex' : 'none',
                            flexDirection: 'column',
                        } }, { children: [_jsx(Typography, Object.assign({ color: "#0057B8", style: {
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis',
                                    whiteSpace: 'nowrap',
                                    maxWidth: '130px',
                                    fontSize: '14px',
                                    lineHeight: '20px',
                                } }, { children: userName })), onClickPhoto && (_jsx(Button, Object.assign({ variant: "ghost", size: "small", endAdornment: _jsx(Icon, { name: "keyboardArrowLeftRounded", size: "14px", color: "#0057b8", style: {
                                        transform: 'rotate(180deg)',
                                    } }), style: {
                                    padding: '0px 0px',
                                    gap: '5px',
                                    height: 'auto',
                                    lineHeight: '13px',
                                }, contentStyle: { fontSize: '13px' } }, { children: "Ir al perfil" })))] }))] })), _jsx(SideBarDividerStyled, {})] })));
};
const SideBar = (_a) => {
    var { onClickPhoto } = _a, props = __rest(_a, ["onClickPhoto"]);
    const { sections, open, onClose, onOpen, variant, wrapperComponent } = props;
    const [openSide, setOpenSide] = useState(open);
    useEffect(() => {
        setOpenSide(open);
        if (open && onOpen) {
            onOpen();
        }
        else if (!open && onClose) {
            onClose();
        }
    }, [open, onOpen, onClose]);
    return (_jsxs(SideBarWrapperStyled, Object.assign({ "data-testid": "sideBar-testId-wrapper" }, props, { open: openSide }, { children: [_jsx(SideBarCloseButtonStyled, Object.assign({ variant: variant, onClick: () => setOpenSide(!openSide) }, { children: _jsx(Icon, { name: "keyboardArrowLeftRounded", color: "#000", size: "16px", style: {
                        transform: `rotate(${openSide ? '0deg' : '-180deg'})`,
                        transition: 'transform 0.3s ease-in-out',
                    } }) })), _jsxs("div", Object.assign({ style: {
                    display: 'grid',
                    gridTemplateRows: 'max-content 1fr max-content',
                    height: '100vh',
                } }, { children: [_jsx(SideBarTopContent, Object.assign({}, props, { onClickPhoto: onClickPhoto, open: openSide, "data-testid": "sideBar-testId-top-content" })), _jsx("div", Object.assign({ "data-testid": "sideBar-testId-middle-content", style: {
                            overflowY: 'scroll',
                            width: openSide || variant === 'mobile' ? '100%' : '105vw',
                            pointerEvents: 'none',
                        } }, { children: _jsx(SideBarStyled, Object.assign({}, props, { children: sections.map((_a) => {
                                var subContentProps = __rest(_a, []);
                                return (_jsx(SideBarContent, Object.assign({}, subContentProps, { level: 0, openSide: openSide, variant: variant, wrapperComponent: wrapperComponent }), getUniqueKey()));
                            }) })) })), _jsx(SideBarBottomContent, Object.assign({}, props, { open: openSide, "data-testid": "sideBar-testId-bottom-content" }))] }))] })));
};
SideBar.defaultProps = {
    photoURL: null,
    sections: [],
    bottomContent: [],
};
export default SideBar;
//# sourceMappingURL=index.js.map